/**
 * 根据提货类型 渲染表单回显
 * 且会在 第二步数据返回才显示
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param deliveryOrderId 编辑时传入此id,等同于将以有否 deliveryOrderId 判断是否编辑状态
 **/
import React from "react";
import {Checkbox} from 'antd';
import Lang from "@/components/Lang/Lang";
import dayjs from "dayjs";
import LogisticsCompanyList from "./logisticsCompanyList/logisticsCompanyList";
// import Consignee from "@/components/Consignee/Consignee";//收货人
import './stepSecond.less'
// import './stepSecondShow.less'
export default class ShowFormData extends React.Component{
    static propTypes = {
    }
    static defaultProps = {
        type: "", //提货类型
        logisticsCompanyList: [], //物流列表
        woodenPalletsPriceAndSymbol:"",// 打木架费用，如 XX 卢布
        address:{}, // 收货人信息 	提货方式是 配送 才会有
        currencySymbol:"",//对应货币
    };
    constructor(props) {
        super(props);
        const fromInitialValues = props.fromInitialValues||{}
        this.state = {
            mapErr:false, //无法加载地图组件
            packageType: fromInitialValues.hasWoodenPallets, //  配送-是否需要打木架	number	0:不需要 1需要
            sendCheck:  fromInitialValues.hasDeliveryService==1?true:false,  // 是否需要送货服务0:不需要 1需要
            logisticsCompanyId:fromInitialValues.logisticsCompanyId||"", // 配送-物流公司id
            packageRemark:fromInitialValues.packageRemark||"",//打包要求
            fieldList:[
                {
                    name:'preDeliveryDate',  // 前往提货时间
                    cnTitleId:'QianWangTiHuoShiJian',
                    cnTitle:"前往提货时间",
                    required: true,
                    type:'Date',
                },
                {
                    type:'OnlyRender', // 联系方式标题
                    onlyRender:<p className={"black89 fw_700 font_16 mt_8 mb_12"}>{__getServerLanguage("LianXiFangShi")}</p>
                },
                {
                    name:'contactName',  // 联系人姓名
                    cnTitleId:'LianXiRenXingMing',
                    cnTitle:"联系人姓名",
                    required: true,
                },
                {
                    name:'contactMobile',  // 联系电话
                    nameTelephoneCode:"contactTelCode",
                    cnTitleId:'LianXiDianHua',
                    cnTitle:"联系电话",
                    required: true,
                    type:'AreaPhone',
                },

            ],
            fieldList2:[
                {
                    type:'OnlyRender',
                    onlyRender:(<>
                        <p className={"black66 font_14"}>
                            {Lang({id:"ZiJiLianXiDiSanFangWuLiuGongSiDaoCangKuTiHuo", default:"自己联系第三方物流公司到仓库提货"})}
                        </p>
                        <p className={"black89 fw_700 font_16 mt_16 mb_2"}>
                            {Lang({id:"QianWangTiHuoShiJian", default:"前往提货时间"})}
                        </p>
                        {fromInitialValues.freeEndDate?<p className={"black66 font_14 mb_4"}>
                            {Lang({id:"MianFeiTingCangZhi", default:"免费停仓至"})}
                            <span className={"ml_4"}>
                               {dayjs(fromInitialValues.freeEndDate).format('YYYY-MM-DD')}
                            </span>
                        </p>:null}
                    </>)
                },
                {
                    name:'preDeliveryDate',  // 前往提货时间
                    required: true,
                    type:'Date',
                    disabled:props.deliveryOrderId?true:false, //编辑状态不可修改时间
                },
                {
                    type:'OnlyRender', // 物流公司信息 标题
                    onlyRender:<p className={"black89 fw_700 font_16 mt_4"}>
                        {Lang({id:"WuLiuGongSiXinXi", default:"物流公司信息"})}
                    </p>
                },
                {
                    name:'logisticsCompanyName',  // 物流公司名字
                    cnTitleId:'WuLiuGongSiMingZi',
                    required: true,
                },
                {
                    name:'logisticsNumber',  // 物流单号
                    cnTitleId:'WuLiuDanHao',
                    cnTitle:"物流单号"
                },
                {
                    type:'OnlyRender',
                    onlyRender:(<>
                        <p className={"black89 fw_700 font_16 mt_4"}>
                            {Lang({id:"LianXiRenXinXi", default:"联系人信息"})}
                        </p>
                        <p className={"black45 font_14 mt_4 mb_12"}>
                            {Lang({id:"WuLiuGongSiLianXiBuShangKeYiLianXiYiXiaRenYuan", default:"物流公司联系不上可以联系以下人员"})}
                        </p>
                    </>)
                },
                {
                    name:'contactName',  // 联系人姓名
                    cnTitleId:'LianXiRenXingMing',
                    cnTitle:"联系人姓名",
                    required: true,
                },
                {
                    name:'contactMobile',  // 联系电话
                    nameTelephoneCode:"contactTelCode",
                    cnTitleId:'LianXiDianHua',
                    required: true,
                    type:'AreaPhone',
                },
            ],
            fieldList3:[
                {
                    type:'OnlyRender',
                    onlyRender:(<>
                        {/* 物流发出日期 */}
                        <p className={"black89 fw_700 font_16 mt_16 mb_2"}>
                            {Lang({id:"WuLiuFaChuRiQi", default:"物流发出日期"})}
                        </p>
                        {/* 免费停仓至 2023-7-1  */}
                        {fromInitialValues.freeEndDate?<p className={"black66 font_14 mb_4"}>
                            {Lang({id:"MianFeiTingCangZhi", default:"免费停仓至"})}
                            <span className={"ml_4"}>
                               {dayjs(fromInitialValues.freeEndDate).format('YYYY-MM-DD')}
                            </span>
                        </p>:null}
                    </>)
                },
                {
                    name:'preDeliveryDate',  // 前往提货时间
                    required: true,
                    type:'Date',
                    disabled:props.deliveryOrderId?true:false, //编辑状态不可修改时间
                },
            ],
            fieldListAddress:[
                {
                    name:'contactName',  // 收件人全名
                    cnTitleId:'ShouJianRenQuanMing',
                },
                {
                    name:'taxRegistrationNo',  // 税务号/护照信息
                    cnTitleId:'ShuiWuHaoHuZhaoXinXi',
                    cnTitle:"税务号/护照信息",
                },
                {
                    name:'contactMobile',  // 联系电话
                    cnTitleId:'LianXiDianHua',
                    type:'AreaPhone',
                },
                {
                    name:'cityName',
                    cnTitleId:'ShouJianRenSuoZaiChengShi',
                    cnTitle:"收件人所在城市",
                    cnPlaceholder:'请输入城市名称',
                    cnPlaceholderId:'QingShuRuChengShiMinCheng',
                },
                {
                    name:'terminalName',
                    cnTitleId:'YunShuGongSiZhongDianZhan',
                    cnTitle:"运输公司终点站",
                    cnPlaceholder:'请注明所需的运输公司终点站',
                    cnPlaceholderId:'QingZhuMingSuoXuDeYunShuGongSiZhongDianZhan',
                },
                {
                    name:'deliveryAddress',
                    cnTitleId:'ChengShiJiaoHuoDiZhi',
                    cnTitle:"城市交货地址",
                    type:"TextArea",
                },
                {
                    name:'remark',
                    cnTitle:'备注',
                    cnTitleId:'BeiZhu',
                    type:"TextArea",
                }
                ],
            visibleAgreement: false, // 协议  窗口
        }
    }
    // 渲染方式
    renderType(value,currentType,title,subTitle=""){
        const { packageRemark } = this.state;
        return (<div className={`selectBox${currentType==value?" on":""}`}>
            <div className={"fw_500"}>{title}</div>
            {subTitle&&<p className={"font_14 black45"}>{subTitle}</p>}
            {value==1&&packageRemark&&<div className={"mt_12"}>
                {/* 打包要求 */}
                <p className={"fw_500"}>
                    {Lang({id:"DaBaoYaoQiu",default:"打包要求"})}
                </p>
                <div className={"word-break-all font_14 black45"}>{packageRemark}</div>
            </div>}
        </div>)
    }
    // 物流公司 回显
    getOneLogistics(logisticsCompanyList,logisticsCompanyId){
        const item = logisticsCompanyList.find(logo=>logo.id==logisticsCompanyId)
        return item?[item]:[]
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    /**
     * 渲染回显的表单数据
     * */
    renderFormData(options=[],fromInitialValues={}){
      let children = []
        options.forEach((item,inx)=>{
            children.push(this.getType(item.type,item,fromInitialValues,inx))
        })
        return children
    }
    getType(type, item,fromInitialValues,inx){
        const langShowText = item.cnTitleId&&item.cnTitleId?Lang({id:item.cnTitleId,default:item.cnTitle}):item.title||'';
        switch (type) {
            case 'OnlyRender':
                return <div key={"only_"+inx}>{item.onlyRender}</div>
            case 'Date':
                return <div className={"mb_12 fw_700"} key={"date_"+inx}>
                    {langShowText&&<div className={"black89 font_16"}>{langShowText}</div>}
                    <p className={"color-err font_14 mt_4"}>{fromInitialValues[item.name]?dayjs(fromInitialValues[item.name]).format('YYYY-MM-DD'):"-"}</p>
                </div>
            case 'AreaPhone':
                return <div className={"mb_12"} key={"common_"+inx}>
                    {langShowText&&<div className={"black89 font_14 fw_700"}>{langShowText}</div>}
                    <p className={"black66 font_14 mt_4"}>+{fromInitialValues.contactTelCode}<span className={"ml_4"}>{fromInitialValues[item.name]}</span></p>
                </div>
            default:
                return <div className={"mb_12"} key={"common_"+inx}>
                    {langShowText&&<div className={"black89 font_14 fw_700"}>{langShowText}</div>}
                    <p className={"black66 font_14 mt_4"}>{fromInitialValues[item.name]}</p>
                </div>
        }
    }

    componentDidMount() {
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { logisticsCompanyList,woodenPalletsPriceAndSymbol,currencySymbol,
            fromInitialValues, type,address,transitCityName } = this.props;
        const { sendCheck, fieldList, packageType,fieldList2,fieldList3, fieldListAddress, logisticsCompanyId,} = this.state;
        return (<div className={"formWrap"}>
            {/* 方式1 -------------------------------------*/}
            {(type=="10"||type=="20")&&this.renderFormData(type=="10"?fieldList:fieldList2,fromInitialValues)}
            {type=="30"&&<>
                <p>
                    {Lang({id:"ShiYongPingTaiZhiDingDeWuLiuGongSi", default:"使用平台指定的物流公司，可以享受送货服务，省钱！"})}
                </p>
                {/* 送至你指定收货地址 */}
                <p className={"mt_20 black89 fw_700 mb_8"}>
                    {Lang({id:"SongZhiNiZhiDingShouHuoDiZhi", default:"送至你指定收货地址"})}
                </p>
                {/* 收货人  */}
                {/*<Consignee address={address} />*/}
                {this.renderFormData(fieldListAddress,fromInitialValues)}
                <p className={"mt_20 black89 fw_700"}>
                    {Lang({id:"XuanZeWuLiuGongSi", default:"选择物流公司"})}
                </p>
                <p className={"font_14 black45"}>
                    {Lang({id:"ZuiZhongYiWuLiuGongiShouFeiWeiZhun", default:"价格仅供参考，最终以物流公司收费为准"})}
                </p>
                {logisticsCompanyList&&logisticsCompanyList.length>0&&<LogisticsCompanyList transitCityName={transitCityName}
                                                                                            logisticsCompanyList={this.getOneLogistics(logisticsCompanyList,logisticsCompanyId)}
                                                                                            currencySymbol={currencySymbol}
                                                                                            logisticsCompanyId={logisticsCompanyId}
                                                                                            className={"mt_12 logoHalf"} />}
                {/* 使用送货服务 */}
                <div className={`sendCheckBox${sendCheck?" sendCheckBoxOn":""}`}>
                    <p><Checkbox checked={sendCheck} disabled>
                        <span className={"black89 fw_700"}>
                            {Lang({id:"ShiYongSongHuoFuWu", default:"使用送货服务"})}
                    </span></Checkbox></p>
                    <p className={"font_14"}>
                        {Lang({id:"ESSAONETiGongMianFeiSongCheFuWu", default:"ESSAONE提供免费送车服务，把你的货物送到物流点，可以节省物流公司到仓库的提货路费。如勾选送货服务，则物流发出时间只能选择每周三。"})}
                    </p>
                </div>
                {this.renderFormData(fieldList3,fromInitialValues)}
                {/*商品是否需要打木架？*/}
                <p className={"mt_20 black89 fw_700"}>
                    {Lang({id:"ShangPinShiFouXuYaoDaMuJia", default:"商品是否需要打木架"})}?
                </p>

                <p className={"font_14 black45"}>
                    {Lang({id:"DaMuJiaTiShi", default:"根据商品是否易碎打木架，商品体积/重量增加导致物流费用有所增加。"})}
                 </p>
                {/* 需要打木架  易碎商品打木架，将增加费用*/}
                {/* 全部不需要  因物流货损，自己承担。《货损费用协议》， 点击全部不需要时弹出并选择同意才回显 勾选成功 ,params:[woodenPalletsPriceAndSymbol]*/}
                {packageType=="1"?this.renderType("1",packageType,Lang({id:"XuYaoDaMuJia", default:"需要打木架"}),
                    Lang({id:"MeiGeMuJiaFeiYongTiShi", default:"每个木架费用大概，将会增加大概10% 的体积"})
                ):this.renderType("0",packageType, Lang({id:"QuanBuBuXuYao", default:"全部不需要"}),
                    Lang({id:"YinWuLiuHuoSunZiJiChengDan", default:"因物流货损，自己承担。"})
                    )}

            </>}

        </div>);
    }
}

